import Vue from 'vue'
// import Shepherd from 'shepherd.js'
import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'

import './mixins'
import './plugins'
import './thirdParty'
// import 'shepherd.js/dist/css/shepherd.css'
// import './assets/shaphered/welcome.css'
import './scss/style.scss'
import './assets/fonts/bebasneue.css'
import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'
import VueGtag from 'vue-gtag'
Vue.config.productionTip = false
// Vue.use(Shepherd)
Vue.use(Toast, {
  position: 'top-right',
  bodyClassName: ['custom-class-1'],
  containerClassName: 'my-container-class',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: false,
  icon: true,
  rtl: false
})

Vue.use(VueGtag, {
  config: {
    id: 'G-BRSVS6R34C'
  }
}, router)

new Vue({
  name: 'Root',
  router,
  store,
  mounted () {
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
    window.addEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },

  beforeDestroy () {
    window.removeEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },
  render: h => h(AppLayout)
}).$mount('#app')
